import BulkOrder from "./BulkOrder";
import SingleOrder from "./SingleOrder";

const AddOrderBox = () => {
  return (
    <div className="flex flex-col justify-start items-center gap-5">
      <SingleOrder />
      <BulkOrder />
    </div>
  );
};

export default AddOrderBox;
